@if (content) {
<sticky-free [order]="0"
             [stickyId]="'page-header'"
             [stickyOff]="isStickyOff"
             [noShadow]="true"
             [style.z-index]="12"
             class="pos-relative">
    <div #cmsNodes
         class="w-12"
         [class.pos-absolute]="isDetached()"
         [elementHeight]="'page-header'"
         [elementHeightOptions]="{topOffset: true, local: false, resizeDebounceTime: 0}">
        @if(!isCheckoutProcess){
        <page-header-promobar class="_promobar"
                              [class._hidden]="isPromobarHidden()"
                              [disabled]="!content.promobarEnabled"
                              (visibilityChange)="watchHeaderHeight()"
                              [content]="content"
                              #cmsNodes></page-header-promobar>
        }
        <header class="w-12 page-header"
                #cmsNodes>
            @if(!isCheckoutProcess){

            <div class="z-2 bg-col-w pos-relative b-b b-col-5">
                <div class="wrap flex-middle flex p-t p-b">
                    <!-- menu / S, M -->
                    <ng-container *ifSize="'MS'">
                        <div class="flex-span-1 flex-nowrap">
                            <!-- menu toggle -->
                            <button type="button"
                                    aria-label="Menu"
                                    class="_icon-wrapper m-l-0"
                                    (click)="toggleOffCanvas()">
                                <i class="_icon"
                                   [ngClass]="isOffCanvasOpen ? 'icon-close' : 'icon-menu'"
                                   aria-hidden="true"></i>
                            </button>
                            <!-- search -->
                            <button type="button"
                                    (click)="openOffCanvasSearch()"
                                    aria-label="Search"
                                    class="_icon-wrapper"
                                    cy-searchbutton>
                                <i class="_icon icon-search"
                                   aria-hidden="true"></i>
                            </button>
                        </div>
                    </ng-container>
                    <!-- logo -->
                    <div class="flex-noshrink m-r-10-x m-r-10-l inline-block pos-relative z-3">
                        <a class="inline-block pos-relative"
                           [routerLink]="'/'">
                            <img [width]="client.isX || client.isL ? 310 : 129"
                                 [height]="client.isX || client.isL ? 31 : 48"
                                 [dfImage]="content.logo"
                                 alt="Acoustical Solutions"
                                 [loaderParams]="{fitIn: true}">
                        </a>
                    </div>
                    <!-- meganav -->
                    <page-header-meganav-menu *ifSize="'XL'"
                                              class="flex-grow"
                                              [items]="content.meganav" />
                    <ng-container *ifSize="'XL'">
                        <href [hrefClass]="'flex flex-middle p-l-2 p-r-2'"
                              [link]="content.additionalUrl">
                            <div class="_additional-image-container inline-flex">
                                <img [ratio]="1"
                                     [width]="39"
                                     [dfImage]="content.additionalImage"
                                     alt="" />
                            </div>
                            <div class="flex flex-column m-l-2">
                                <p class="col-1 p2"
                                   *iCms="'additionalTitle' of content"></p>
                                <p class="col-1 h3"
                                   *iCms="'additionalDescription' of content"></p>
                            </div>
                        </href>
                        <ng-container [ngTemplateOutlet]="accountBtns" />

                        <!-- search -->
                        <page-header-search-form class="m-l-7" />
                    </ng-container>
                    <!-- basket -->
                    <div class="flex-span-1 right"
                         *ifSize="'SM'">
                        <ng-container [ngTemplateOutlet]="accountBtns" />
                        <a [routerLink]="'/cart'"
                           aria-label="Basket"
                           (click)="trackBasketClick()"
                           class="_icon-wrapper">
                            <ng-container [ngTemplateOutlet]="basketBtn" />
                        </a>
                    </div>
                    @if(isBasketInteractionExperiment){
                    <a *ifSize="'XL'"
                       [routerLink]="'/cart'"
                       aria-label="Basket"
                       (click)="trackBasketClick()"
                       class="_icon-wrapper">
                        <ng-container [ngTemplateOutlet]="basketBtn" />
                    </a>
                    }@else{
                    <button *ifSize="'XL'"
                            [iCmsModalOpen]="minibasketModalId"
                            (click)="trackBasketClick()"
                            aria-label="Basket"
                            class="_icon-wrapper inline-block"
                            cy-basketbagbutton>
                        <ng-container [ngTemplateOutlet]="basketBtn" />
                    </button>
                    }
                </div>
            </div>
            <!-- meganav content -->
            <ng-container *afterContentInit>
                <page-header-meganav-content *ifSize="'XL'"
                                             class="block z-1"
                                             [items]="content.meganav"
                                             #cmsNodes />
            </ng-container>
            @if(content.additionalTitle || content.additionalDescription || content.additionalImage) {
            <div *ifSize="'SM'"
                 class="_additional-content-mobile"
                 [elementHeight]="'page-header-additional-content-mobile'"
                 [class._hidden]="isPromobarHidden() || isOffCanvasOpen">
                <href [hrefClass]="'flex flex-middle flex-justify-center bg-col-52 p-t-2 p-b-2'"
                      [link]="content.additionalUrl">
                    <div class="_additional-image-container inline-flex">
                        <img [ratio]="1"
                             [width]="28"
                             [dfImage]="content.additionalImage"
                             alt="" />
                    </div>
                    <div class="flex flex-middle">
                        <p class="col-1 p2 m-l-2"
                           *iCms="'additionalTitle' of content"></p>
                        <p class="col-1 s1 m-l-1"
                           *iCms="'additionalDescription' of content"></p>
                    </div>
                </href>
            </div>
            }
            }
            @if(isCheckoutProcess){
            <div class="z-2 bg-col-w pos-relative _checkout-wrapper">
                <div class="wrap flex flex-middle flex-justify-between _checkout-content">
                    <div class="flex-span-1 flex flex-middle">
                        <i class="icon-lock"></i>
                        <p class="p1 m-l"
                           *ifSize="'XL'">Secure Checkout</p>
                    </div>
                    <a class="inline-block pos-relative"
                       [routerLink]="'/'">
                        <img [dfImage]="content.logo"
                             alt="Acoustical Solutions"
                             [height]="client.isX || client.isL ? 30 : 38"
                             [width]="client.isX || client.isL ? 290 : 98"
                             [loaderParams]="{fitIn: true}">
                    </a>
                    <div class="flex-span-1"></div>
                </div>
            </div>
            }

        </header>
    </div>
</sticky-free>
}


<ng-template #basketBtn>
    <span pageHeaderBasketQtyBullet
          class="inline-flex flex-middle">
        <i class="_icon icon-basket"
           aria-hidden="true"></i>
    </span>
</ng-template>

<ng-template #accountBtns>
    <a routerLink="/account"
       cy-loginbutton
       *ifLoggedIn
       title="My Account"
       class="_icon-wrapper"><i class="_icon icon-account"
           aria-hidden="true"></i></a>
    <!-- sign in -->
    <a routerLink="/login"
       routerLinkActive="is-active"
       cy-loginbutton
       *ifNotLoggedIn
       title="Sign In"
       class="_icon-wrapper">
        <i class="_icon icon-account"
           aria-hidden="true"></i>
    </a>
</ng-template>